import { render, staticRenderFns } from "./ModalNtrPrasymasRole.vue?vue&type=template&id=46c19e3c&scoped=true&"
import script from "./ModalNtrPrasymasRole.vue?vue&type=script&lang=js&"
export * from "./ModalNtrPrasymasRole.vue?vue&type=script&lang=js&"
import style0 from "./ModalNtrPrasymasRole.vue?vue&type=style&index=0&id=46c19e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c19e3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})
